module.exports = __webpack_public_path__ + "assets/icons/alert-outline.svg";